import React, { useRef, useState } from 'react';
import { ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import ButtonWithLoading from './ButtonWithLoading';

const SplitButton = ({ options, handleClick, isLoading = false, ...props }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleMenuItemClick = (index) => {
    handleClick(options[index]);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef} {...props}>
        <ButtonWithLoading isLoading={isLoading} onClick={() => handleClick(options[0])}>
          {options[0]?.label}
        </ButtonWithLoading>
        <ButtonWithLoading size="small" isLoading={isLoading} onClick={handleToggle} sx={{ height: '100%' }}>
          <ArrowDropDownIcon />
        </ButtonWithLoading>
      </ButtonGroup>
      <Popper style={{ zIndex: 1 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper
              sx={{ width: anchorRef.current?.offsetWidth }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) =>
                    index === 0 ? null : (
                      <MenuItem key={option.name} disabled={index > 1} onClick={() => handleMenuItemClick(index)}>
                        {option.label}
                      </MenuItem>
                    )
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default SplitButton;
